// app_client/src/layouts/MainLayout.jsx
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import NotificationCenter from '../components/layout/NotificationCenter';
import useAuthStore from '../store/authStore';

const MainLayout = () => {
  const { user, loading } = useAuthStore();

  // Token kontrolü hala devam ediyorsa bir şey gösterme (veya loading spinner)
  if (loading) return null;

  // Giriş yapmamış kullanıcıyı Login'e fırlat (Route koruması)
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen bg-slate-50 overflow-hidden">
      {/* Sabit Sidebar */}
      <Sidebar />

      {/* Dinamik İçerik Alanı */}
      <main className="flex-1 overflow-y-auto p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-end mb-4">
            <NotificationCenter />
          </div>
          {/* Sayfa içerikleri buraya gelecek */}
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
